// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { infoSlideStyles } from "@turnerBlueprint/App/Widgets/InfoSlide/InfoSlide";
import IconArrowRight from "@turnerBlueprint/XDL/Icons/IconArrowRight";
import { color, createLinkIconStyles, ellipsis, hideElementOnPrint, xScreen } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

infoSlideStyles.container = {
    css: css`
        height: 100%;
        border: 1px solid ${color("common.border")};
        background-color: ${color("commn.ui1")};
        box-shadow: 0 2px 0 0 ${color("common.ui4")};
        display: flex;
        flex-direction: column;
        gap: 8px;
        ${hideElementOnPrint}
    `,
};

infoSlideStyles.image = {
    css: css`
        width: 100%;
        height: auto;
        margin-bottom: 4px;

        img {
            max-height: 180px;
            width: 100%;
            ${xScreen("lte", "md")} {
                max-height: 150px;
            }
            ${xScreen("lte", "sm")} {
                max-height: 165px;
            }
        }
    `,
};

infoSlideStyles.titleTypography = {
    variant: "h4",
    css: css`
        padding: 13px;
        margin-bottom: 0;
        padding-bottom: 0;
    `,
};

infoSlideStyles.descriptionTypography = {
    css: css`
        flex-grow: 1;
        ${TypographyStyle} {
            margin-bottom: 0;
            font-size: 14px;
            line-height: 22px;
            padding: 0 13px;
            color: ${color("common.ui6")};
        }
        ${({ maxNumberOfDescriptionLines }: any) =>
            css`
                ${ellipsis(maxNumberOfDescriptionLines)};
            `}
    `,
};

infoSlideStyles.action = {
    ...createLinkIconStyles(
        IconArrowRight,
        {
            css: css`
                margin: 13px;
                margin-top: 16px;
                width: fit-content;
            `,
        },
        {
            size: 15,
            lineHeight: "18px",
        },
        {
            size: 16,
            css: css`
                &,
                & svg {
                    width: 8px;
                }
            `,
        },
        "right",
    ),
};
